import { Component, OnInit, Input} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerConfig, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';

import { getDateAsUTC } from 'src/app/core';
import { CommonService } from 'src/app/core/common.service';

@Component({
  selector: 'eos-date-range-filter',
  templateUrl: './date-range-filter.component.html',
  styleUrls: ['./date-range-filter.component.css']
})
export class DateRangeFilterComponent implements OnInit {

  @Input() public startDate?: Date;
  @Input() public endDate?: Date;
  @Input() public header = "Select start date range";
  onSubmit: Function;
  
  constructor(public modal: NgbActiveModal,public common:CommonService) { }
  bsConfig: Partial<BsDatepickerConfig> = {
    dateInputFormat: 'DD-MMM-YY',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    customTodayClass: 'custom-today-class',
    adaptivePosition: true,
  };

  ngOnInit() {

  }
  errorMessage = '';
  errorMessageEndDate = '';

  onValueChange(datePicker: BsDatepickerDirective,rangeDate) {
    if (datePicker && datePicker._bsValue && rangeDate) {
      rangeDate=='startDate'?this.errorMessage = '':this.errorMessageEndDate=''; // Clear any existing error message if month is valid
      if (datePicker == null) {
        return;
      }
      else{
        const rawInputText =(document.getElementById(rangeDate)as HTMLInputElement).value;
        if(rawInputText.length>0 && this.common.omitSpecialChar(rawInputText)){
          rangeDate=='startDate'?this.errorMessage = 'Special character other than - is not allowed':this.errorMessageEndDate='Special character other than - is not allowed'; 
          return false;
        }
        const dateArray = rawInputText.split('-');
        if (dateArray.length != 3) {
            return false;
        }
        else{
          const day=dateArray[0];
          const month = dateArray[1];
          const year = dateArray[2];
          var fullYear=parseInt(datePicker._bsValue.toString().split(" ")[3]);
          fullYear = year.length == 4 ? parseInt(year) : fullYear;
          if (!Number.isNaN(parseInt(month)) && parseInt(month) >= 1 && parseInt(month) <= 12) {
            datePicker._bsValue.setMonth(parseInt(month) - 1);
          }
          else if (parseInt(month) > 12) {
            datePicker._bsValue.setMonth(11);
            rangeDate=='startDate'?this.errorMessage = 'Please enter a valid calender date.':this.errorMessageEndDate='Please enter a valid calender date.'; 
          }
          if (year.length > 2) {
            datePicker._bsValue.setFullYear(parseInt(year))
            if(parseInt(year) < 1900 || parseInt(year) > 2100 ){
              rangeDate=='startDate'?this.errorMessage = 'Please enter a valid calender date.':this.errorMessageEndDate='Please enter a valid calender date.'; 
            }
            if(this.isLeapYear(year) &&  parseInt(month)===2 &&  parseInt(day)===29){
              datePicker._bsValue.setMonth(1);
              datePicker._bsValue.setDate(29);
            }
          }
          if (parseInt(month)>12 || ([1, 3, 5, 7, 8, 10, 12].includes(parseInt(month)) && parseInt(day) > 31) || ([4, 6, 9, 11].includes(parseInt(month)) && parseInt(day) > 30)
            || (parseInt(month) == 2 && !this.isLeapYear(fullYear) && parseInt(day) > 28) || (parseInt(month) == 2 && this.isLeapYear(fullYear) && parseInt(day) > 29))
            rangeDate=='startDate'?this.errorMessage = 'Please enter a valid calender date.':this.errorMessageEndDate='Please enter a valid calender date.'; 
          datePicker._bsValue.setHours(0);
          datePicker._bsValue.setMinutes(0);
          datePicker._bsValue.setSeconds(0);
          datePicker._bsValue.setMilliseconds(0);
        }
      }
    }
  }
  onDateSubmit() {
    this.onSubmit(this.startDate, this.endDate);
    this.modal.close();
  }
    isDateRangeValid(): boolean {
    return !!this.startDate && !!this.endDate;
  }

  clear(d,rangeDate) {
    rangeDate=='startDate'?this.errorMessage = '':this.errorMessageEndDate=''; 
    d.bsValue = null;
  }
  isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }
}
